import { openDB } from 'idb';

export const initDB = async () => {
  return openDB('DistrictDB', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('District_Polygon')) {
        const store = db.createObjectStore('District_Polygon', {
          keyPath: 'DistrictName',
        });
        store.createIndex('Polygon', 'Polygon', { unique: false });
      }
    },
  });
};

export const saveDistricts = async (districts) => {
  const db = await initDB();
  const tx = db.transaction('District_Polygon', 'readwrite');
  const store = tx.objectStore('District_Polygon');
   await store.clear();
  districts.forEach((district) => {
    store.put(district);
  });
  await tx.done;
};

export const getDistrict = async (name) => {
  const db = await initDB();
  return db.get('District_Polygon', name);
};

export const getAllDistricts = async () => {
  const db = await initDB();
  return db.getAll('District_Polygon');
};
